import "./styles/general.scss";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Layout from "components/layout/Layout";
import Configurator from "views/configurator/Configurator";
import Results from "views/results/Results";
import Catalogue from "views/catalogue/Catalogue";
import Form from "views/form/Form";
import MyHelmet from "utils/helmet";
import ScrollToTop from "components/ScrollToTop";

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <MyHelmet />
    <Layout>
      <Switch>
        <Route exact path="/" component={Configurator} />
        <Route path="/catalogue" component={Catalogue} />
        <Route path="/results" component={Results} />
        <Route path="/form" component={Form} />
        <Redirect to="/" />
      </Switch>
    </Layout>
  </BrowserRouter>
);

export default App;
